/**
 * Generate a client-side idempotency key for a workflow-run submission. Created
 * when the run form opens so retries of the same intent de-duplicate on the BE.
 */
export const generateIdempotencyKey = (): string => {
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }

  return `wfr-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
